import request from "./common";

const twoFaApi = {
    confirm: (totp: number): Promise<unknown> => {
        return request<unknown, number>("/user/2fa/confirm", "POST", totp);
    },
};

export default twoFaApi;
